import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

const ComingSoon = ({ pageName }) => {
  return (
    <>
      <SEO
        title={`${pageName} - Growth Hacking | Email Marketing Expert`}
        description={`Our ${pageName} page is coming soon. Growth Hacking offers expert email marketing services including Kit.com, ActiveCampaign automation, deliverability optimization, and newsletter monetization. Contact us for a free consultation.`}
        canonical={`/${pageName.toLowerCase().replace(' ', '-')}`}
      />
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-orange-50 to-white px-6 pt-20">
        <div className="text-center max-w-2xl">
          <div className="text-6xl font-bold text-orange-600 mb-4">Coming Soon</div>
          <h1 className="text-4xl font-bold text-gray-900 mb-6">{pageName} - Growth Hacking Email Marketing</h1>
          <p className="text-xl text-gray-700 mb-6 leading-relaxed">
            We're working hard to bring you comprehensive information about our {pageName.toLowerCase()}. 
            In the meantime, feel free to explore our services or book a free consultation to discuss 
            your email marketing needs.
          </p>
          <p className="text-lg text-gray-600 mb-8">
            Transform your email list into a predictable revenue engine with our expert email marketing services. 
            We specialize in Kit.com, ActiveCampaign, automation, and deliverability optimization.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-orange-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-orange-700 transition-all shadow-lg"
            >
              <ArrowLeft className="w-5 h-5" />
              Back to Home
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-4 rounded-full font-semibold border-2 border-gray-200 hover:border-orange-600 transition-all"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;
